export default __webpack_public_path__ + "static/media/regulatory--circular-intersection--g4.daf2c245.png";